// import { asyncRoutes, constantRoutes } from '@/router'
import { constantRoutes } from '@/router'
import { isAdminRole } from '@/utils/permission'
import Layout from '@/layout'
import checkPermission from '../../utils/permission'
import { MessageBox } from 'element-ui'
import { manageIndexCount } from '@/api/workflow'
const _import = require(`./common/import_${process.env.NODE_ENV}.js`)
const STAT_REPORT_PERMISSIONS = ['module_StatisticalReportsModule', 'subsystem_GeneralReport']
/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  const routeRoles = (route.roles && route.roles.length > 0)
  const routeMetaRoles = (route.meta && route.meta.roles && route.meta.roles.length > 0)
  if (routeRoles || routeMetaRoles) {
    const pass = roles.some(role => (routeRoles ? route.roles : route.meta.roles).includes(role))
    // todo some bug
    return pass
  } else {
    return true
  }
}

/**
 * 将菜单数据转化为 路由解析格式
 */
async function preProcessMenus(currentTenantMenus, language, currentUserInfo, currentOfficeId) {
  // console.log('preProcessMenus+currentTenantMenus:', currentTenantMenus)
  // return asyncRoutes 可优化为递归
  // .filter(item => { return (item.h5ComponentName && item.h5Path) })
  let routes = currentTenantMenus.map(item => {
    let h5ExtendInfo = item.h5ExtendInfo ? JSON.parse(item.h5ExtendInfo) : {} // 扩展信息
    const icon = item.h5Icon
    const activeIcon = item.activeIcon.split('/').pop()
    const route = { uuid: item.uuid, module: item.code, hidden: !item.display, path: item.h5Path, menuId: item.menuId, alwaysShow: true, component: Layout, root: true, name: item.h5ComponentName, children: [], meta: { title: item.chineseLabel, enTitle: item.englishLabel, jaTitle: item.japaneseLabel, ruTitle: item.russianLabel, thTitle: item.thaiLabel, viTitle: item.vietnameseLabel, icon, activeIcon }, ...h5ExtendInfo }
    const children = item.children

    const routeChilren = children.filter(c => {
      if (c.code === 'SEBooking' && checkPermission(['role_query_' + c.code]) && !checkPermission(['module_' + c.code]) && !checkPermission(['report_' + c.code])) {
        return false
      }
      // console.log('route =>', c.h5Path, c.chineseLabel, c.openH5Url)
      if (!c.h5ComponentName || !c.h5Path || !c.openH5Url) {
      // if (!c.h5ComponentName || !c.h5Path) {
        // 未开发功能菜单，直接跳转到flex-cargo
        // c.h5Path = `${process.env.VUE_APP_CARGO}/ssoForward?sessionId=${currentUserInfo.sessionId}&branchId=${currentOfficeId}&language=${language}&module=${c.code}`
        // c.h5Path = getCargoJumpUrl({ code: c.code, language, sessionId: currentUserInfo.sessionId, branchId: currentOfficeId }) // // Desc: 有动态参数，需要在点击时确定
        c.jumpCargo = true
        // console.log('jumpCargo=', c.chineseLabel, c.jumpCargo)
        // console.log('c.h5Path', c.h5Path)
      }
      if (item.code === 'Star-Schema') {
        if (c.h5ComponentName === 'JmReport') {
          return checkPermission(STAT_REPORT_PERMISSIONS)
        }
        return checkPermission(['report_' + c.code + '_' + c.code])
      }
      return checkPermission(['module_' + c.code, 'report_' + c.code, 'role_query_' + c.code])
    }).map(c => {
      // console.log('h5ExtendInfo', c.h5ExtendInfo)
      h5ExtendInfo = c.h5ExtendInfo ? JSON.parse(c.h5ExtendInfo) : {} // 扩展信息
      // icon = ''// 子菜单不要图标
      // console.log('c.h5Component', c.h5Component)
      const commonReturn = { uuid: c.uuid, jumpCargo: true, hidden: !c.display, module: c.code, path: c.h5Path, menuId: c.menuId, component: null, name: c.h5ComponentName, meta: { title: c.chineseLabel, enTitle: c.englishLabel, jaTitle: c.japaneseLabel, ruTitle: c.russianLabel, thTitle: c.thaiLabel, viTitle: c.vietnameseLabel, icon: '', parentIcon: activeIcon }, ...h5ExtendInfo }
      try {
        if (c.code === 'StatisticalReportsModule') {
          console.log('[permission][StatisticalReportsModule] buildRoute:beforeImport', {
            h5Component: c.h5Component,
            h5Path: c.h5Path,
            h5ComponentName: c.h5ComponentName,
            openH5Url: c.openH5Url,
            jumpCargo: c.jumpCargo
          })
        }
        return { ...commonReturn, jumpCargo: c.jumpCargo || false, component: c.h5Component ? _import(`cargo/v0/${c.h5Component}`) : null }
      } catch (e) {
        if (c.code === 'StatisticalReportsModule') {
          console.log('[permission][StatisticalReportsModule] buildRoute:importError', e)
        } else {
          console.log('router error:', e)
        }
        return { ...commonReturn }
      }
    })
    route.children = routeChilren
    return route
  })
  routes = routes.filter(p => {
    // 没有孩子不展示
    return p.children && p.children.length
  })
  if (routes.length === 0) {
    MessageBox.alert('你的账户没有任何权限, 请联系系统管理员.', {
      confirmButtonText: '确定',
      type: 'warning' })
    return routes
  }
  // console.log('动态路由=》routes', routes)
  return routes
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  carousel: 2,
  routes: [],
  addRoutes: [],
  analysisList: [],
  permissionSeparateOffice: null, // 权限是否区分公司
  menuRefreshId: 0 // 菜单刷新ID
}

const mutations = {
  SET_CAROUSEL: (state, status) => {
    console.log(status)
    state.carousel = status
  },
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },
  SET_ANALYSIS_LIST: (state, analysisList) => {
    state.analysisList = analysisList
  },
  SET_PERMISSION_SEPARATE_OFFICE: (state, permissionSeparateOffice) => {
    state.permissionSeparateOffice = permissionSeparateOffice
  },
  MENU_REFRESH_ID_PLUS_ONE: (state) => {
    state.menuRefreshId += 1
  }
}

const actions = {
  async generateRoutes({ commit, rootGetters }, roles) {
    const asyncRoutes = await preProcessMenus(rootGetters.currentTenantMenus, rootGetters.language, rootGetters.userInfo, rootGetters.currentOfficeId)
    return new Promise(resolve => {
      let accessedRoutes
      if (isAdminRole(roles)) {
        accessedRoutes = asyncRoutes
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
      }
      // CARGO-33542 BPM流程引擎三期 CARGO-35175 5.7.优化
      const approvalMattersRoutes = accessedRoutes.filter(route => route.path === '/ApprovalMatters')
      if (approvalMattersRoutes && approvalMattersRoutes.length > 0) {
        manageIndexCount().then(res => {
          approvalMattersRoutes[0].badgeCount = res.data.pendingProcessingCount
        })
      }
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },
  setAnalysisList({ commit }, data) {
    commit('SET_ANALYSIS_LIST', data)
  },
  setCarousel({ commit }, status) {
    commit('SET_CAROUSEL', status)
  },
  setPermissionSeparateOffice({ commit }, data) {
    commit('SET_PERMISSION_SEPARATE_OFFICE', data)
  },
  menuRefreshIdPlusOne({ commit }) {
    commit('MENU_REFRESH_ID_PLUS_ONE')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
